export interface Item {
  updated: number;
  created: number;
  releaseStage: string;
  learnVersion: string;
  lastReleaseVersion?: string;
  tenantsCount: number;
  id: string;
}

export interface ResponseData {
  items: Item[];
}

export interface ReleaseStageDialogData {
  releaseStage: string;
  learnVersion: string;
}

export interface JobInput {
  state: string;
}

export interface JobRequest {
  jobId: string;
  jobInput?: JobInput;
  tenantList?: string[];
  installationList?: string[];
  scheduledStartTime?: string;
}

export enum JobIds {
  UPDATE = 'UpdateTenantState',
  UPGRADE = 'UpgradeLearnInstance',
}

export enum TenantStates {
  AVAILABLE = 'AVAILABLE',
}
